import { createContext } from "react";

interface loader {
  show?: boolean;
  message?: string;
}

interface LoaderContextProps {
  loader: loader;
  showLoader(loader: loader): void;
}

export const LoaderContext = createContext<LoaderContextProps>({
  loader: {
    show: false,
    message: "",
  },
  showLoader: () => {},
});
